import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ELASTICSEARCHBOX_FEATURE_KEY, ElasticSearchBoxState } from './elastic-search-box.reducer';

export const getElasticSearchBoxState = createFeatureSelector<ElasticSearchBoxState>(
  ELASTICSEARCHBOX_FEATURE_KEY,
);

export const getElasticSearchBoxSearchJson = createSelector(
  getElasticSearchBoxState,
  (state: ElasticSearchBoxState) => state?.searchJson,
);
export const selectElasticSearchBoxSearchResults = createSelector(
  getElasticSearchBoxState,
  (state: ElasticSearchBoxState) => state?.searchResult,
);
export const selectElasticSearchBoxBusinessSearchResults = createSelector(
  getElasticSearchBoxState,
  (state: ElasticSearchBoxState) => state?.searchBusinessResult,
);
export const getLoadingStatus = createSelector(
  getElasticSearchBoxState,
  (state: ElasticSearchBoxState) => state?.loading,
);
